import _ from "lodash";
import { cloneDeep, get, isObject } from "lodash";
import moment from "moment-timezone";
import React, { useState } from "react";

import Button from "@/components/UI/Button";
import DatePicker from "@/components/UI/DatePicker";
import images from "@/utils/images";
import Input from "@/components/UI/Input";
import { Select, TextArea } from "@/components/UI/StyledInput";

import { DISCHARGE_SCHEMA } from "../../constants/discharge-schema";
import { dischargeDateExists } from "../../helpers/discharge-exists";

export function EditableDischargeV2(props) {
  const {
    classes,
    dateIndex,
    dischargeValues,
    index,
    setDateIndex,
    setDischargeValues,
    setShowDischargeDatePickers,
    showDischargeDatePickers,
  } = props;

  const [discharges, setDischarges] = useState(_.cloneDeep(dischargeValues));

  const pickNoteDate = (dateStr, eventType) => {
    let parts = dateStr.split("-");
    let session_date = parts[1] + "/" + parts[2] + "/" + parts[0];

    handleDischargeChange("discharge_date", session_date, dateIndex);
    const datePickers = showDischargeDatePickers;

    if (eventType !== "monthChange") {
      datePickers[dateIndex] = false;
    }
    setShowDischargeDatePickers(datePickers);
  };

  const handleDischargeChange = (elementName, value, index) => {
    const currentDischarges = cloneDeep(discharges);

    if (!isObject(currentDischarges[index])) {
      currentDischarges[index] = {};
    }

    currentDischarges[index][elementName] = value;
    setDischargeValues(currentDischarges);
    setDischarges(currentDischarges);
  };

  const addDischarge = () => {
    const clonedDischarges = _.cloneDeep(discharges);

    clonedDischarges.push({});
    setDischarges(clonedDischarges);
  };

  const removeDischarge = (index) => {
    const clonedDischarges = _.cloneDeep(discharges);

    if (discharges.length > 0) {
      clonedDischarges.splice(index, 1);
    } else {
      clonedDischarges.splice(index, 1, {});
    }
    setDischarges(clonedDischarges);
  };

  const getSelectElement = (formEl, rowValue, rowIndex) => {
    return (
      <div
        className={classes && classes.colEditable ? classes.colEditable : "col-6"}
        key={formEl.name + rowIndex}
      >
        <div className="FormGroup">
          <label className="Label">{formEl.elementConfig.label}</label>
          <Select
            changeHandler={(e) => handleDischargeChange(formEl.name, e.target.value, rowIndex)}
            options={formEl.elementConfig.options}
            placeholder={{
              display: formEl.elementConfig.placeholder,
              value: formEl.elementConfig.placeholder,
            }}
            value={rowValue}
          />
        </div>
      </div>
    );
  };

  const getDatepickerElement = (formEl, rowValue, rowIndex) => {
    return (
      <div
        className={classes && classes.colEditable ? classes.colEditable : "col-6"}
        key={formEl.name + rowIndex}
      >
        <div
          className="dischargev2-delete-button float-right cursor"
          key={`crossContainer${rowIndex}`}
          onClick={(rowIndex) => {
            removeDischarge(rowIndex);
          }}
        >
          <img className="img-fluid" key={`cross${rowIndex}`} src={images("./icons/cross.svg")} />
        </div>
        <div className="FormGroup" key={`fg${rowIndex}`}>
          <label className="Label">{formEl.elementConfig.label}</label>
          <div className="d-flex">
            <Input
              className="Input"
              disabled
              onChange={(e) => handleDischargeChange(formEl.name, e.target.value, rowIndex)}
              placeholder={formEl.elementConfig.placeholder}
              value={rowValue}
            />
            <img
              className="ml-2 img-fluid cursor"
              onClick={() => {
                const datePickers = [...showDischargeDatePickers];

                datePickers[rowIndex] = !datePickers[rowIndex];
                setShowDischargeDatePickers(datePickers);
                setDateIndex(rowIndex);
              }}
              src={images("./icons/calender-icon.svg")}
            />
          </div>
        </div>

        {showDischargeDatePickers[rowIndex] && (
          <div
            className="PrScheduleAvailability__DatePicker-wpr-absolute NoteDatePicker"
            key={`dp${rowIndex}`}
          >
            <div>
              <DatePicker
                externalCtx={
                  dischargeDateExists(dischargeValues, index)
                    ? moment(dischargeValues[index]["discharge_date"], "MM/DD/YYYY")
                    : moment()
                }
                onDaySelect={pickNoteDate}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const getTextareaElement = (formEl, rowValue, rowIndex) => {
    return (
      <div
        className={classes && classes.colEditable ? classes.colEditable : "col-11"}
        key={formEl.name + rowIndex}
      >
        <div className="FormGroup">
          <label className="Label">{formEl.elementConfig.label}</label>
          <TextArea
            classes="Input"
            ids="Input"
            onChange={(e) => handleDischargeChange(formEl.name, e.target.value, rowIndex)}
            placeholder={formEl.elementConfig.placeholder}
          />
        </div>
      </div>
    );
  };

  const buildDefaultView = (rowValue, rowIndex) => {
    let elements = {};

    DISCHARGE_SCHEMA.forEach((formEl) => {
      const value = get(rowValue, [formEl.name], "");

      if (formEl.elementType === "select") {
        elements[formEl.elementType] = getSelectElement(formEl, value, rowIndex);
      } else if (formEl.elementType === "datepicker") {
        elements[formEl.elementType] = getDatepickerElement(formEl, value, rowIndex);
      } else if (formEl.elementType === "textarea") {
        elements[formEl.elementType] = getTextareaElement(formEl, value, rowIndex);
      }
    });

    return (
      <div className="col">
        <div className="row">
          {elements["select"]}
          {elements["datepicker"]}
        </div>
        <div className="row">{elements["textarea"]}</div>
      </div>
    );
  };

  if (discharges.length === 0) {
    addDischarge();
  }

  const display = discharges.map((value, index) => buildDefaultView(value, index));

  return (
    <>
      {display}
      <Button
        className="col-6 ml-3 mb-4 new-discharge-button"
        key={index}
        onClick={() => {
          addDischarge();
          const datePickers = showDischargeDatePickers;

          datePickers.push(false);
          setShowDischargeDatePickers(datePickers);
        }}
        type="button"
      >
        Add new discharge date
      </Button>
    </>
  );
}
